import React from "react";
import "./LoaderSVG.css";
import {CirclesWithBar} from 'react-loader-spinner'

const LoaderSVG = () => (
    <div class="Loader-Container">
        <div class="loader">
            <CirclesWithBar
                height="100"
                width="100"
                color="#bd04d2"
                outerCircleColor="#bd04d2"
                innerCircleColor="#bd04d2"
                barColor="#bd04d2"
                ariaLabel="circles-with-bar-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>
    </div>
);

export default LoaderSVG;
